app.service('productTopSeeRecommended',function(productCardConfig, callback, console, logData) {
	var $self, $previewItems, $carouselItems, $preview, config, timeout, active=false;

	function load() {
		var url = logData.showRecommendationsFromAWSonProductCard() ? '/user-personalized-see-also-carousel.ltr' : '/see-also-carousel.ltr';
		var data = {
			productId:config.id,
			with_attributes: true
		};
		if (logData.showRecommendationsFromAWSonProductCard()) {
			data.userId = logData.customerId();
		};
		$.ajax({
			url:url,
			data:data,
			success: function(html) {
				loadSuccess(html, data);
			},
			error:function(){
				loadError(data);
			}
		});
	}
	function loadSuccess(html, data) {
		$self.removeClass('loading').html(html);
		console.log('Załadowano karuzelę "zobacz także".');
		$preview = $self.find('.see-also-preview');
		$previewItems = $preview.find('.product-box');
		$carouselItems = $self.find('.see-also-carousel .simple-product-item');
	}
	function loadError(data) {
		console.log('Błąd ładowania karuzeli "zobacz także".');
	}
	function setEvents() {

	}
	function hideItem(){
		$previewItems.removeClass('active');
		$carouselItems.removeClass('active');
	}
	function hide(){
		$preview.slideUp();
		$carouselItems.removeClass('active');
		active=false;
	}
	function toogleItem(index){
		if(active!==false && index==active){
			hide();
		}else{
			showItem(index);
		}
	}
	function showItem(index){
		console.log(index)
		function show(){
			hideItem();
			active = index;
			$previewItems.eq(index).addClass('active');
			$carouselItems.eq(index+1).addClass('active');
		}
		if(active===false){
			show();
			$preview.slideDown();
		}else {
			clearTimeout(timeout);
			$preview.addClass('loading');
			timeout = setTimeout(function(){
				show();
				$preview.removeClass('loading');
			}, 1000);
		}
	}
	function setElements() {
		$self = $('#top-see-recommended');

		$self.on('click', 'li.simple-product-item', function(){
			toogleItem($(this).index()-1);
		});
		$self.on('click', '.close', function(){
			hide();
		});
	}
	function init() {
		config=productCardConfig.getData();
		setElements();
		setEvents();
		load();
	}
	return {
		init
	};
});
